module.exports = {
      id: "olympic-usage",
      viewBox: "0 0 11.388 19.966",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#olympic",
      toString: function () {
        return this.url;
      }
    }